import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useContent } from '../context/ContentContext';

const Testimonials = () => {
  const { testimonials } = useContent();
  return (
    <section className="relative py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Loved across Botswana
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#0b2f5c] tracking-tight mb-4">
            Real people. Real stories.
          </h2>
          <p className="text-slate-600 leading-relaxed">
            From Gaborone to Maun, thousands trust MaLife every day.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.slice(0, 3).map((t, i) => (
            <div
              key={t.id || t.name}
              className={`relative rounded-3xl p-8 border transition-all hover:-translate-y-1 hover:shadow-xl ${
                i === 1
                  ? 'bg-gradient-to-br from-[#0b2f5c] to-[#164a8f] border-transparent text-white shadow-xl'
                  : 'bg-slate-50 border-slate-200'
              }`}
            >
              <Quote className={`w-8 h-8 mb-4 ${i === 1 ? 'text-sky-300' : 'text-sky-400'}`} />

              <div className="flex gap-0.5 mb-4">
                {[...Array(t.rating || 5)].map((_, k) => (
                  <Star key={k} className={`w-4 h-4 ${i === 1 ? 'fill-sky-300 text-sky-300' : 'fill-amber-400 text-amber-400'}`} />
                ))}
              </div>

              <p className={`text-base leading-relaxed mb-6 ${i === 1 ? 'text-white/90' : 'text-slate-700'}`}>
                “{t.quote}”
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm ${
                  i === 1 ? 'bg-white/15 text-sky-200' : 'bg-sky-100 text-sky-700'
                }`}>
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className={`text-sm font-bold ${i === 1 ? 'text-white' : 'text-[#0b2f5c]'}`}>{t.name}</div>
                  <div className={`text-xs ${i === 1 ? 'text-sky-200' : 'text-slate-500'}`}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
